import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import SearchDropdown from "./SearchDropdown";
import { HTTP } from '../../api/resources'

export default function SearchBar({user, url, optimize = false}) {
    const [searchInput, setSearchInput] = useState('')
    const [isDirty, setIsDirty] = useState(false)
    const [completed, setCompleted] = useState(false)
    const [users, setUsers] = useState(user)

    useEffect(() => {
        setIsDirty(false)
    }, [user])

    const handleClose = () => {
        // Timer is used to allow user to click link if suggestion box is active, takes 200milliseconds, barely noticable
        setTimeout(() => setIsDirty(false), 200)
    }

    const submissionURL = (event) => {
        event.preventDefault()
        let url = `${window.location.pathname}?q=${searchInput}`

        if (window.location.search.includes('archived=true')) url = `${url}&archived=true`

        window.location = url
    }

    const filterSearch = () => {
        if (!searchInput) {
            return users; // Return all users if search input is empty
        }
        
        const lowercasedInput = searchInput.toLowerCase();
    
        return users.filter(user => {
            return (
                String(user.username).toLowerCase().includes(lowercasedInput) ||
                user.name.toLowerCase().includes(lowercasedInput) ||
                user.email.toLowerCase().includes(lowercasedInput) || 
                (user.additional_emails && user.additional_emails.length > 0 && user.additional_emails.some(email => 
                    email.value.toLowerCase().includes(lowercasedInput))
                )
            );
        });    
    }


    return (
        <div className="search-bar-js" onBlur={handleClose}>
            <form id="search-bar">
            <div className="form-group" data-toggle="tooltip" data-placement="right" title="Search profile fields for any full or partial query.">
                <div className="input-group">
                    <input type="text" name="q" onChange={(e) => {setSearchInput(e.target.value); setIsDirty(true)}} placeholder="Search by name, email, username, phone number or any other profile field" autoComplete="off" className="form-control" />
                    <div className="input-group-append">
                        <button className="btn btn-light btn-border" onClick={(e) => submissionURL(e)}><i className="fa fa-search"></i></button>
                    </div>
                </div>
            </div>
            </form>
            {isDirty && searchInput.length > 0 && completed &&
            <SearchDropdown data={filterSearch()} parameter={searchInput} link={url} onClick={() => setIsDirty(true)} />
            }

            {isDirty && searchInput.length > 0 && !completed &&
            <SearchDropdown data={filterSearch()} parameter={searchInput} link={url} onClick={() => setIsDirty(true)} />
            }
        </div>
    )
}
